import { getSearchResultsRoute } from '@/api/apiConstants'
import { postWithAuth } from '@/api/httpRequests'
import { searchQueryLimit } from '@/shared/constants/appConstants'

const getSearchResults = async (query: string) => {
    const requestBody = JSON.stringify({ query, limit: searchQueryLimit })
    return await postWithAuth(getSearchResultsRoute, true, requestBody)
}

export default getSearchResults
